import { Checkbox, Empty, Typography } from 'antd'

export type FolderDimensionOption = {
  id: number
  name: string
  is_manual: boolean
}

type Props = {
  dimensions: FolderDimensionOption[]
  value?: number[]
  onChange?: (ids: number[]) => void
}

function dimensionLabel(dim: FolderDimensionOption): string {
  return dim.is_manual ? '系统目录' : dim.name
}

export function DimensionMultiBrowsePanel({ dimensions, value = [], onChange }: Props) {
  if (!dimensions.length) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无虚拟分类" />
  }

  const selected = new Set(value)

  const toggle = (id: number, checked: boolean) => {
    const next = new Set(value)
    if (checked) next.add(id)
    else next.delete(id)
    onChange?.(Array.from(next).sort((a, b) => a - b))
  }

  return (
    <div className="app-browse-dimension-list">
      {dimensions.map((dim) => (
        <label key={dim.id} className="app-browse-dimension-item">
          <Checkbox
            checked={selected.has(dim.id)}
            onChange={(e) => toggle(dim.id, e.target.checked)}
          />
          <span className="app-browse-dimension-item-label">{dimensionLabel(dim)}</span>
          {!dim.is_manual ? (
            <Typography.Text type="secondary" className="app-browse-dimension-item-hint">
              虚拟分类
            </Typography.Text>
          ) : null}
        </label>
      ))}
    </div>
  )
}
